<template>
  <div class="upload-field-renderer">
    <F360Upload
      :accept="ACCEPTED_FILES.join(',')"
      v-model:file-list="fileList"
      ref="uploadRef"
      drag
      multiple
      :auto-upload="false"
      :error="Boolean(error)"
    />
    <span v-if="error" class="upload-field-renderer__error">
      {{ error }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { MimeTypes } from "@/core/composables/download/types";
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";
import F360Upload from "@/ui/components/Uploads/Base/F360Upload.vue";
import { ref, watch } from "vue";
import type { UploadUserFile } from "element-plus";

defineProps<{
  campo: TIntegracaoCampoModel;
  modelValue: string[];
  error?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string[]): void;
}>();

const fileList = ref<UploadUserFile[]>([]);

const ACCEPTED_FILES = [
  MimeTypes.ZIP,
  MimeTypes.PDF,
  MimeTypes.JPG,
  MimeTypes.PNG,
  MimeTypes.XLS,
  MimeTypes.XLS,
  MimeTypes.DOC,
  MimeTypes.XML,
  MimeTypes.PFX,
  ".pfx"
];

const readAsDataUrl = (file: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

watch(fileList, async (newVal: UploadUserFile[]) => {
  const blobs = newVal
    .map((file) => file.raw ?? null)
    .filter((raw): raw is NonNullable<typeof raw> => raw !== null);

  try {
    const contents = await Promise.all(blobs.map(readAsDataUrl));
    emit("update:modelValue", contents);
  } catch {
    emit("update:modelValue", []);
  }
});
</script>

<style scoped lang="scss">
@use "@/ui/styles/theme/f360-theme" as *;

.upload-field-renderer {
  width: 100%;

  &__error {
    display: block;
    margin-top: 4px;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: $input-icon-color-error;
  }
}
</style>
